import React, { useEffect } from "react";
import { Form, Select, Tag, Typography } from "antd";
import categoryMetaData from "../data/category";

const { Text } = Typography;
const { Option } = Select;

const renderTags = (tagId, i) => {
  const tag = categoryMetaData.find((item) => item.id === tagId); // Find the corresponding label in metaData

  if (!tag) return null; // If no match is found, return null

  return (
    <Tag key={i}>
      <Text style={{ fontSize: "1rem" }}>{tag.label}</Text>
    </Tag>
  );
};

const CategorySelector = ({ state = {}, readOnly }) => {
  const { data, form, rules, onChange } = state;

  //for sync antd with state
  useEffect(() => {
    form?.setFieldsValue({ category: data });
  }, [data]);

  return readOnly ? (
    data?.length > 0 ? (
      data.map((tagId, i) => {
        return renderTags(tagId, i);
      })
    ) : null
  ) : (
    <Form form={form} layout="vertical">
      <Form.Item name="category" rules={rules}>
        <Select
          value={data}
          mode="multiple"
          size="large"
          style={{ width: "20rem" }}
          placeholder="Select categories"
          onChange={(value) => {
            onChange({ category: value });
          }}
        >
          {categoryMetaData.map((category, i) => (
            <Option key={i} value={category.id}>
              {category.label}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </Form>
  );
};

export default CategorySelector;
